import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { authAPI } from '../utils/api';
import { toast } from 'sonner';
import { Link } from 'react-router-dom';
import './ForgotPassword.css';

export const ForgotPassword = () => {
  const { i18n } = useTranslation();
  const isGerman = i18n.language === 'de';
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await authAPI.forgotPassword({ email });
      setSent(true);
      toast.success(isGerman 
        ? 'Ein neues Passwort wurde an Ihre E-Mail gesendet!'
        : 'A new password has been sent to your email!');
    } catch (error) {
      toast.error(isGerman ? 'Fehler beim Senden' : 'Failed to send new password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-page">
      <div className="forgot-password-container">
        <div className="forgot-password-card">
          <h1>{isGerman ? 'Passwort vergessen?' : 'Forgot Password?'}</h1>
          
          {!sent ? (
            <>
              <p className="subtitle">
                {isGerman
                  ? 'Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen ein neues Passwort.'
                  : 'Enter your email address and we will send you a new password.'}
              </p>

              <form onSubmit={handleSubmit} className="forgot-form">
                <div className="form-group">
                  <label htmlFor="email">{isGerman ? 'E-Mail-Adresse' : 'Email Address'}</label>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    data-testid="forgot-email-input"
                  />
                </div>

                <button type="submit" className="submit-button" disabled={loading}>
                  {loading ? (isGerman ? 'Lädt...' : 'Loading...') : (isGerman ? 'Neues Passwort senden' : 'Send New Password')}
                </button>
              </form>
            </>
          ) : (
            <div className="success-message">
              <p>✓ {isGerman ? 'E-Mail wurde gesendet!' : 'Email has been sent!'}</p>
              <p className="small">
                {isGerman
                  ? 'Bitte überprüfen Sie Ihren Posteingang. Ändern Sie Ihr Passwort nach der Anmeldung aus Sicherheitsgründen.'
                  : 'Please check your inbox. Change your password after login for security reasons.'}
              </p>
            </div>
          )}

          <Link to="/login" className="back-link">
            ← {isGerman ? 'Zurück zur Anmeldung' : 'Back to Login'}
          </Link>
        </div>
      </div>
    </div>
  );
};
